import { render, staticRenderFns } from "./BtnAgenda.vue?vue&type=template&id=13116f5b&scoped=true&"
import script from "./BtnAgenda.vue?vue&type=script&lang=js&"
export * from "./BtnAgenda.vue?vue&type=script&lang=js&"
import style0 from "./BtnAgenda.vue?vue&type=style&index=0&id=13116f5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13116f5b",
  null
  
)

export default component.exports